/**
 * @desc 界面管理
 * @author qsj qushijie@qfei.cn
 */
export default {
  与表单设计保持一致: '与表单设计保持一致',
  详情页设置: '详情页设置',
  前台打开的数据详情页可选择以下任一种模式生效: '前台打开的数据详情页可选择以下任一种模式生效',
  详情可查看: '详情可查看',
  使用说明: '使用说明',
  设置: '设置',
  提示: '提示',
  与标设计页同步逻辑: '与标设计页同步逻辑',
  与表单设计页保持同步: '与表单设计页保持同步',
  '与表单设计页字段排布、分组配置保持同步': '与表单设计页字段排布、分组配置保持同步',
  自定义详情页: '自定义详情页',
  '在表单设计页字段排布、分组配置基础上进行自定义设置，并开放添加重复字段、页签等功能': '在表单设计页字段排布、分组配置基础上进行自定义设置，并开放添加重复字段、页签等功能',
  '字段的新增、删除会同步至详情页,移动不会同步至详情页': '字段的新增、删除会同步至详情页;移动不会同步至详情页',
  分组的任何操作都不会同步至详情页: '分组的任何操作都不会同步至详情页',
  '切换至与表单设计页保持同步后，对象数据的详情页将以此模式配置为准，且自定义详情页配置仍然会保存供后续使用，是否确认切换?': '切换至与表单设计页保持同步后，对象数据的详情页将以此模式配置为准，且自定义详情页配置仍然会保存供后续使用，是否确认切换?',
  '切换至自定义详情页后，对象数据的详情页将以自定义详情页配置为准，是否确认切换？': '切换至自定义详情页后，对象数据的详情页将以自定义详情页配置为准，是否确认切换？'
};
